module.exports = __webpack_public_path__ + "genratePoints_24x24.png?901c647af7d9e4060ac77d7cf21348b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/genratePoints_24x24.png
// module id = 1037
// module chunks = 0